import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLanguageContext } from "../../../Context/LanguageContext";
import CommonHeader from "../CommonHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",

    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  navigation: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  timeline: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50%",
  },
  timelineStep: {
    flex: 1,
    width: "33.33%",

    height: "4px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "2px",
    transition: "background-color 0.3s ease",
    margin: `0 ${theme.spacing(0.5)}px`,
  },
  activeStep: {
    backgroundColor: theme.palette.secondary.main,
  },
  checklistTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontStyle: "italic",
    marginBottom: theme.spacing(1),
  },
  accountIconButton: {
    padding: 0,
  },
  accountIcon: {
    width: "3rem",
    height: "3rem",
  },
  headerStyle: {
    padding: 8,
  },
}));

export default function Header({
  handleBack,
  checkListTitle,
  handleNextChapter,
  handlePreviousChapter,
  chapterListSetting,
  logoutClick,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="row">
        <div className="col-10 d-flex">
          {checkListTitle !== "" && (
            <>
              <IconButton className="pl-0 pt-0" onClick={handleBack}>
                <ArrowBack />
              </IconButton>
              <Typography variant="h5" className={classes.checklistTitle}>
                {" "}
                {checkListTitle}
              </Typography>
            </>
          )}
        </div>
        <CommonHeader logoutClick={logoutClick} classes={classes} />
      </div>

      {chapterListSetting && (
        <>
          <div>
            <p>
              {chapterListSetting.activeChapter +
                "/" +
                chapterListSetting.totalChapter +
                " " +
                chapterListSetting.nameChapter}
            </p>
          </div>
          <div className={classes.navigation}>
            <IconButton
              disabled={!(chapterListSetting.activeChapter > 1)}
              onClick={(e) => {
                if (chapterListSetting.activeChapter > 1) {
                  handlePreviousChapter();
                }
              }}
            >
              <ArrowBack />
            </IconButton>

            <div className={classes.timeline}>
              {Array.from({ length: chapterListSetting.totalChapter }).map(
                (_, index) => (
                  <div
                    key={index}
                    className={`${classes.timelineStep} ${
                      index === chapterListSetting.activeChapter - 1
                        ? classes.activeStep
                        : ""
                    }`}
                  />
                )
              )}
            </div>
            <IconButton
              disabled={
                chapterListSetting.activeChapter ===
                chapterListSetting.totalChapter
              }
              onClick={() => {
                if (
                  chapterListSetting.activeChapter !==
                  chapterListSetting.totalChapter
                ) {
                  handleNextChapter("allBlock");
                }
              }}
            >
              <ArrowForward />
            </IconButton>
          </div>
        </>
      )}
    </div>
  );
}
